var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo1Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 83,
    viewBox: "0 0 52 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.1958 67.9208V70.2523H36.5273H49.5123V80.6685H2.94865V70.2523H15.805H18.1364V67.9208V22.4255V20.094H15.805H2.94865V10.451H6.53785C11.5489 10.451 15.2988 9.88891 17.831 8.35912C19.1674 7.55179 20.1598 6.47969 20.7902 5.14779C21.215 4.25028 21.4451 3.29917 21.5466 2.33146H34.1958V67.9208Z",
    fill: "url(#paint0_linear_1_384)",
    stroke: "#EDEFFF",
    strokeWidth: 4.66292
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_384",
    x1: 24,
    y1: 5.5,
    x2: 24,
    y2: 78.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A387D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C4E2",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo1Img);
export default __webpack_public_path__ + "static/media/video__1__img.a8872ad26a3312de57005dd95f50e544.svg";
export { ForwardRef as ReactComponent };